const Header = () => {
    return (
        <section>
            <div className="text-center">
                <img alt='CAIPY' src="/static/frontlogo.png" />
                <h1 style={{ fontFamily: 'none' }}>CAIPY</h1>
            </div>
        </section>
    );
};

export default Header;